import {
  DashboardComponentPropsBase,
} from "components/pages/dashboard/components/interfaces";
import { ReportOptions } from "models/component-print-models";
import { Align } from "types/types";
import { DatasetLoadingConf } from "../charts/interfaces";

export const SPARKLINE_CLICK_SCOPE_CLASS = "sparkline-select-area";

export interface SparkLineProps extends DashboardComponentPropsBase<ReportOptions>, AdvancedProps{
  /**
   * Index of chart.
   *
   * @minimum 0
   * @TJS-type integer
   */
  chartIndex?: number;
  allCharts?: Record<number, string> | undefined;
  decimalPlaces?: number;
  labelFontSize?: string;
  sparkLineWidth?: number;
  dataset: string | null;
  lineColor?: string;
  lineWidth?: number;
  count?: number;
  unit?: string;
  updateFrequency?: number;
  advanced?: boolean;
  height?: number;
  maxAge?: number;
  chartTitle?: string;
  isMultipleCharts?: boolean;
  generalProperties?: GeneralProperties;
  multipleCharts: SparkLineProps[];
  useLoadConf?: boolean;
  loadConf?: DatasetLoadingConf;
  maxYAxis?: number;
  minYAxis?: number;
  downsampleInterval?: number;
  useDecimalsFromHundred?: boolean;
}

export interface GeneralProperties {
  hideValues?: boolean;
  expandAll?: boolean;
  expandedChartIndex?: number;
  chartsInOneBox?: boolean;
  displayTitlesInRow?: boolean;
}

export interface AdvancedProps {
  data: Datapoint[];
  baseline?: LineConfig;
  minLine?: LineConfig;
  maxLine?: LineConfig;
  count?: number;
  updateFrequency?: number;
  showYAxis?: boolean;
  referenceTime?: string;
  fromDate?: Date;
  toDate?: Date;
  isMultipleCharts?: boolean;
  isExpanded?: boolean;
  multipleCharts?: SparkLineProps[];
  allCharts?: Record<number, string> | undefined
  setExpandedChartIndex?: (index: number) => void;
  isMultipleChartsInOneBox?: boolean;
  useDecimalsFromHundred?: boolean;
}

export type Datapoint = { y: number; x: Date };

export type Usages = "none" | "dataset" | "constant";

export enum ValuePosition {
  TOP = "top",
  BOTTOM = "bottom",
  LEFT = "left",
  RIGHT = "right",
}

export interface LineConfig {
  usage?: Usages;
  constant?: number;
  dataset?: string;
  width?: number;
  color?: string;
  fillAboveColor?: string;
  fillBelowColor?: string;
}

export interface ISparkLineHandlerProps {
  title: string;
  isLoading: boolean;
  chartIndex?: number;
  dataset: string;
  dataArray: number[];
  lineColor?: string;
  lineWidth?: number;
  lastValueTime: Date | null;
  sparklineWidth?: number;
  labelFontSize?: string;
  decimalPlaces?: number;
  unit?: string;
  height?: number;
  vertical?: Align;
  horizontal?: Align;
  maxAge?: number;
  advanced?: boolean;
  advancedProps?: AdvancedProps;
  generalProperties?: GeneralProperties;
  isMultipleCharts?: boolean;
  stringValueMapper?: number;
  chartTitle?: string;

  minYAxis?: number;
  maxYAxis?: number;
}

export type ValueLabel = {
  disconnected: boolean;
  value?: number;
  title?: string;
  decimalPlaces: number;
  content: string | React.ReactNode;
  bgColor: string;
  textColor?: string;
};
